import React, { CSSProperties, PropsWithChildren } from 'react';
import classNames from 'classnames';
import styles from './Cell.module.scss';
import gapStyles from './styles/Gap.module.scss';
import templateStyles from './styles/Template.module.scss';

export const Cell = ({ children, style, ...props }: Props) => (
    <div className={classes(props)} style={style}>
        {children}
    </div>
);

const classes = ({ full, fill, fit, className }: Props) => {
    return classNames(className, styles.default, templateStyles.cell, gapStyles.cell, {
        [styles.full]: full,
        [styles.fill]: fill,
        [styles.fit]: fit
    });
};

type Props = PropsWithChildren<{
    style?: CSSProperties;
    full?: boolean;
    fill?: boolean;
    fit?: boolean;
    className?: string;
}>;